(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ur-dice-discovery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ur-dice-discovery')) return;
    const randomIndex = n => {
      if (n < 1) return 0;
      if (!window.crypto?.getRandomValues) return Math.floor(Math.random() * n);
      const limit = Math.floor(4294967296 / n) * n;
      const value = new Uint32Array(1);
      do { window.crypto.getRandomValues(value); } while (value[0] >= limit);
      return value[0] % n;
    };
    const materialOf = p => {
      const title = `${p.title} ${p.type || ''}`.toLowerCase();
      if (/petrified wood/.test(title)) return 'gemstone';
      if (/resin|liquid[ -]?core/.test(title)) return 'resin';
      if (/glass|prism/.test(title)) return 'glass';
      if (/gemstone|amethyst|agate|aagte|obsidian|labradorite|quartz|jasper|tiger.?eye|fluorite|opalite|lapis|malachite|aventurine|sodalite|howlite|turquoise|sandstone/.test(title)) return 'gemstone';
      if (/metal|alloy|brass|steel|aluminum|aluminium|copper|zinc/.test(title)) return 'metal';
      if (/wood|walnut|ebony/.test(title)) return 'wood';
      return 'other';
    };
    const formatOf = (p,v) => {
      const text = v.title.toLowerCase();
      if (/\b([2-6]|[1-9][0-9]+)\s*(pcs|pieces?|pack)\b|\bpack of\s*([2-9]|[1-9][0-9]+)\b/.test(text)) return 'other';
      if (/\b(full|complete|whole)\s*(dice\s*)?set\b|\bset\b|\b[7-9][ -]?(pcs|pieces?)\b/.test(text)) return 'set';
      if (/\bd(4|6|8|10|12|20|100|%)\b|\bsingle\b/.test(text)) return 'single';
      if (text === 'default title') {
        if (/\bset\b/i.test(p.title)) return 'set';
        if (/\bd(4|6|8|10|12|20|100)\b/i.test(p.title)) return 'single';
      }
      return 'other';
    };
    // A closed, bevelled icosahedron. The renderer only paints camera-facing
    // surfaces; labels live in each face's own plane, never in screen space.
    const D20 = (() => {
      const add=(a,b)=>a.map((v,i)=>v+b[i]);
      const sub=(a,b)=>a.map((v,i)=>v-b[i]);
      const mul=(a,k)=>a.map(v=>v*k);
      const dot=(a,b)=>a.reduce((s,v,i)=>s+v*b[i],0);
      const cross=(a,b)=>[a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]];
      const unit=a=>mul(a,1/Math.hypot(...a));
      const center=ps=>mul(ps.reduce(add,[0,0,0]),1/ps.length);
      const phi=(1+Math.sqrt(5))/2;
      const vertices=[[-1,phi,0],[1,phi,0],[-1,-phi,0],[1,-phi,0],[0,-1,phi],[0,1,phi],[0,-1,-phi],[0,1,-phi],[phi,0,-1],[phi,0,1],[-phi,0,-1],[-phi,0,1]].map(unit);
      const triangles=[[0,11,5],[0,5,1],[0,1,7],[0,7,10],[0,10,11],[1,5,9],[5,11,4],[11,10,2],[10,7,6],[7,1,8],[3,9,4],[3,4,2],[3,2,6],[3,6,8],[3,8,9],[4,9,5],[2,4,11],[6,2,10],[8,6,7],[9,8,1]];
      // Face numbers and print apex follow Panda Game Manufacturing's standard
      // D20 net (2025 template), not sequential/spindown numbering. This keeps
      // the physical adjacency, handedness and print orientation together.
      const labelLayout=[[2,0],[20,0],[14,0],[4,0],[18,0],[8,9],[12,4],[5,2],[11,6],[6,8],[17,3],[7,3],[1,3],[19,3],[3,3],[10,5],[15,11],[13,10],[9,7],[16,1]];
      const faces=triangles.map((ids,index)=>{
        const points=ids.map(i=>vertices[i]),c=center(points),normal=unit(c);
        const [number,apex]=labelLayout[index];
        const up=unit(sub(vertices[apex],c)),right=unit(cross(up,normal));
        return {ids,number,apex,center:c,normal,up,right,points:points.map(p=>add(mul(p,.92),mul(c,.08)))};
      });
      const surfaces=faces.map(f=>({...f,kind:'face'}));
      const edges=new Map();
      for(const f of faces)for(let k=0;k<3;k++){
        const a=f.ids[k],b=f.ids[(k+1)%3],key=[a,b].sort((x,y)=>x-y).join('-');
        if(!edges.has(key))edges.set(key,[]);
        edges.get(key).push({a,b,pa:f.points[k],pb:f.points[(k+1)%3]});
      }
      for(const pair of edges.values()){
        const [a,b]=pair;
        surfaces.push({kind:'bevel',points:[a.pa,a.pb,b.a===a.b?b.pa:b.pb,b.a===a.b?b.pb:b.pa]});
      }
      for(let i=0;i<vertices.length;i++){
        const n=vertices[i],near=faces.filter(f=>f.ids.includes(i)).map(f=>f.points[f.ids.indexOf(i)]);
        const c=center(near),u=unit(sub(near[0],c)),v=cross(n,u);
        near.sort((a,b)=>Math.atan2(dot(sub(a,c),v),dot(sub(a,c),u))-Math.atan2(dot(sub(b,c),v),dot(sub(b,c),u)));
        surfaces.push({kind:'corner',points:near});
      }
      for(const s of surfaces){s.center=center(s.points);s.normal=unit(cross(sub(s.points[1],s.points[0]),sub(s.points[2],s.points[0])));if(dot(s.center,s.normal)<0){s.points.reverse();s.normal=mul(s.normal,-1);}}
      const axis=(a,r)=>[...mul(unit(a),Math.sin(r/2)),Math.cos(r/2)];
      const product=(a,b)=>[a[3]*b[0]+a[0]*b[3]+a[1]*b[2]-a[2]*b[1],a[3]*b[1]-a[0]*b[2]+a[1]*b[3]+a[2]*b[0],a[3]*b[2]+a[0]*b[1]-a[1]*b[0]+a[2]*b[3],a[3]*b[3]-dot(a.slice(0,3),b.slice(0,3))];
      const rotate=(p,q)=>{const u=q.slice(0,3),t=mul(cross(u,p),2);return add(p,add(mul(t,q[3]),cross(u,t)));};
      const align=(a,b)=>{const d=dot(a,b);return d<-.999999?axis(cross(a,Math.abs(a[0])<.9?[1,0,0]:[0,1,0]),Math.PI):unit([...cross(a,b),1+d]);};
      const slerp=(a,b,t)=>{
        let cosine=dot(a,b);if(cosine<0){b=mul(b,-1);cosine=-cosine;}
        if(cosine>.9995)return unit(add(mul(a,1-t),mul(b,t)));
        const angle=Math.acos(Math.min(1,cosine));return add(mul(a,Math.sin((1-t)*angle)/Math.sin(angle)),mul(b,Math.sin(t*angle)/Math.sin(angle)));
      };
      const rest=(face,yaw)=>{
        const level=align(faces[face].normal,[0,1,0]),printUp=rotate(faces[face].up,level);
        // A zero-yaw top face reads from the viewer's side. Rolls still receive
        // a random yaw, while the idle pose starts with a readable natural 20.
        return product(axis([0,1,0],Math.PI-Math.atan2(printUp[0],printUp[2])+yaw),level);
      };
      return {add,sub,mul,dot,cross,unit,vertices,faces,surfaces,axis,product,rotate,slerp,rest,inradius:Math.hypot(...faces[0].center)};
    })();
    class DiceDiscovery extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        this.seen = new Set();
        this.unavailable = new Set();
        this.busy = false;
        this.selected = null;
        const find = s => this.querySelector(s);
        this.ui = {material:find('[data-material]'),format:find('[data-format]'),reset:find('[data-reset]'),roll:find('[data-roll]'),skip:find('[data-skip]'),motion:find('[data-motion]'),count:find('[data-count]'),rollMessage:find('[data-roll-message]'),empty:find('[data-empty]'),result:find('[data-result]'),status:find('[data-status]'),title:find('[data-title]'),price:find('[data-price]'),variant:find('[data-variant]'),image:find('[data-image]'),imageLink:find('[data-image-link]'),link:find('[data-product-link]'),cart:find('[data-cart-link]'),add:find('[data-add]'),canvas:find('canvas')};
        try {
          const config = JSON.parse(find('[data-dice-config]').textContent);
          this.text = config.text;
          this.products = [...new Map(config.products.filter(p => !p.requires_selling_plan && /dice|\bd(4|6|8|10|12|20)\b/i.test(p.title) && !/mystery|blind bag|blind box|gift card|free gift|gift random|100% off|necklace|dice tray|dice cage|dice box|display|stand|storage|custom|personali[sz]ed|pre.?order/i.test(p.title)).map(p => [p.id,p])).values()];
          this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency || 'USD',currencyDisplay:'code'});
        } catch(e) { this.ui.roll.disabled = true; return; }
        const listen = (el,event,fn) => el.addEventListener(event,fn,{signal:this.abort.signal});
        for (const field of ['material','format']) listen(this.ui[field],'change',()=>this.updateFilters());
        listen(this.ui.reset,'click',()=>{this.ui.material.value='all';this.ui.format.value='set';this.updateFilters();});
        listen(this.ui.roll,'click',()=>this.roll());
        listen(this.ui.skip,'click',()=>this.finishAnimation?.());
        listen(this.ui.variant,'change',()=>this.showVariant());
        listen(this.ui.add,'click',()=>this.add());
        for(const link of [this.ui.link,this.ui.imageLink])listen(link,'click',()=>{
          const v=this.currentVariant();if(!v)return;
          window.URDiceTracking?.publish('dice_product_click',{entry_location:this.trackingContext?.entry||'unknown',product_id:String(this.selected.id),variant_id:String(v.id)});
        });
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.ui.motion.checked = this.motion.matches;
        listen(this.ui.motion,'change',()=>{if(this.ui.motion.checked)this.finishAnimation?.();});
        this.motion.addEventListener('change',e=>{this.ui.motion.checked=e.matches;if(e.matches)this.finishAnimation?.();},{signal:this.abort.signal});
        this.initCanvas();
        this.updateFilters();
      }
      disconnectedCallback() {
        this.finishAnimation?.();
        this.abort?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.initialized = false;
      }
      status(message,error=false) {this.ui.status.textContent=message;this.ui.status.dataset.error=String(error);}
      eligibleVariants(p) {
        const format=this.ui.format.value;
        return (p.variants||[]).filter(v=>v.available && !this.unavailable.has(String(v.id)) && Number.isFinite(Number(v.price)) && Number(v.price)>0 && (format==='all'||formatOf(p,v)===format));
      }
      pool() {return this.products.filter(p=>(this.ui.material.value==='all'||materialOf(p)===this.ui.material.value)&&this.eligibleVariants(p).length);}
      updateFilters() {
        if(this.busy)return;
        this.seen.clear();this.selected=null;this.ui.result.hidden=true;this.ui.empty.hidden=false;this.ui.rollMessage.hidden=true;
        const pool=this.pool();
        this.ui.count.textContent=this.text.count.replace('[count]',pool.length);
        this.ui.roll.disabled=!pool.length;
        this.ui.roll.textContent=this.text.roll;
        this.status(pool.length?'':this.products.length?this.text.no_match:this.text.no_pool,!pool.length);
      }
      lock(state) {
        this.busy=state;
        for(const name of ['material','format','reset','roll','variant','add'])this.ui[name].disabled=state;
        if(!state)this.ui.roll.disabled=!this.pool().length;
      }
      async request(url,options={}) {
        const controller=new AbortController();
        const stop=()=>controller.abort();
        this.abort.signal.addEventListener('abort',stop,{once:true});
        const timer=setTimeout(stop,12000);
        try {
          const response=await fetch(url,{credentials:'same-origin',...options,signal:controller.signal});
          const data=await response.json();
          if(!response.ok){const error=new Error('Request failed');error.status=response.status;error.payload=data;throw error;}
          return data;
        } finally {clearTimeout(timer);this.abort.signal.removeEventListener('abort',stop);}
      }
      async refreshProduct(p) {
        const data=await this.request(`${this.dataset.root}products/${encodeURIComponent(p.handle)}.js`);
        if(String(data.id)!==String(p.id))throw new Error('Product mismatch');
        p.variants=data.variants.map(v=>({...v,image:v.featured_image?.src||null}));
        return p;
      }
      async roll() {
        if(this.busy)return;
        const pool=this.pool();
        if(!pool.length){this.updateFilters();return;}
        let fresh=pool.filter(p=>!this.seen.has(p.id));
        if(!fresh.length){this.seen.clear();fresh=pool.length>1?pool.filter(p=>p.id!==this.selected?.id):pool;}
        const chosen=fresh[randomIndex(fresh.length)];
        this.trackingContext=window.URDiceTracking?.begin(this)||null;
        this.lock(true);this.status(this.text.rolling);this.ui.roll.textContent=this.text.rolling;this.ui.rollMessage.hidden=true;
        try {
          const refreshed=this.refreshProduct(chosen).then(product=>({product}),error=>({error}));
          await this.animate();
          this.ui.rollMessage.textContent=this.rollPhrase();this.ui.rollMessage.hidden=false;
          this.status(this.text.loading);
          const result=await refreshed;
          if(result.error)throw result.error;
          if(!this.isConnected)return;
          if(!this.eligibleVariants(chosen).length){this.status(this.text.unavailable,true);this.selected=null;this.ui.result.hidden=true;this.ui.empty.hidden=false;return;}
          this.seen.add(chosen.id);this.selected=chosen;
          window.URDiceTracking?.remember(this.trackingContext,chosen,this.eligibleVariants(chosen).map(v=>v.id));
          this.renderProduct();
          window.URDiceTracking?.publish('dice_result_view',{entry_location:this.trackingContext?.entry||'unknown',product_id:String(chosen.id),variant_id:String(this.currentVariant()?.id||'')});
        } catch(e) {if(this.isConnected)this.status(this.text.error,true);}
        finally {if(this.isConnected){this.lock(false);this.ui.roll.textContent=this.text.again;this.ui.count.textContent=this.text.count.replace('[count]',this.pool().length);}}
      }
      renderProduct() {
        const p=this.selected;
        this.ui.title.textContent=p.title;
        this.ui.variant.replaceChildren(...this.eligibleVariants(p).map(v=>new Option(`${v.title} · ${this.money.format(v.price/100)}`,String(v.id))));
        this.ui.result.hidden=false;this.ui.empty.hidden=true;this.showVariant();
        this.status(`${this.rollPhrase()} ${this.text.result} ${p.title}`);
      }
      rollPhrase() {return this.lastRoll===20?this.text.natural_twenty:this.text.roll_message.replace('[number]',this.lastRoll);}
      currentVariant() {return this.selected?.variants.find(v=>String(v.id)===this.ui.variant.value);}
      showVariant() {
        const v=this.currentVariant();if(!v)return;
        this.ui.price.textContent=this.money.format(v.price/100);
        const target=new URL(this.selected.url,location.origin);target.searchParams.set('variant',v.id);
        if(this.trackingContext&&window.URDiceTracking?.allowed())target.searchParams.set('ur_dice',this.trackingContext.roll);
        const link=target.pathname+target.search;
        this.ui.link.href=link;this.ui.imageLink.href=link;
        this.ui.image.src=v.image||v.featured_image?.src||this.selected.image||'';
        this.ui.image.alt=`${this.selected.title} — ${v.title}`;
        this.ui.add.textContent=this.text.add;this.ui.add.disabled=false;this.uncertainVariant=null;
        this.status('');
      }
      async add() {
        if(this.busy||!this.selected)return;
        const variant=this.currentVariant();if(!variant?.available)return;
        const variantId=String(variant.id),oldPrice=variant.price;
        this.lock(true);this.ui.add.textContent=this.text.adding;this.status('');
        let attempted=false;
        try {
          await this.refreshProduct(this.selected);
          const current=this.selected.variants.find(v=>String(v.id)===variantId);
          if(!current?.available){this.unavailable.add(variantId);this.renderProduct();this.status(this.text.unavailable,true);return;}
          if(current.price!==oldPrice){this.renderProduct();if(this.eligibleVariants(this.selected).some(v=>String(v.id)===variantId)){this.ui.variant.value=variantId;this.showVariant();}this.status(this.text.changed,true);return;}
          attempted=true;
          const properties=window.URDiceTracking?.properties(this.trackingContext,this.selected,current)||{};
          const added=await this.request(`${this.dataset.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:current.id,quantity:1,properties}]})});
          const confirmed=(added.items||[added]).some(item=>String(item.variant_id||item.id)===String(current.id));
          if(confirmed)window.URDiceTracking?.publish('dice_add_to_cart',{entry_location:this.trackingContext?.entry||'unknown',product_id:String(this.selected.id),variant_id:String(current.id),add_path:'discovery_widget'});
          this.status(this.text.added);
          this.ui.add.textContent=this.text.added;
          this.ui.cart.focus({preventScroll:true});
          this.addedVariant=variantId;
        } catch(e) {
          if(e.status===422){this.unavailable.add(variantId);this.status(this.text.unavailable,true);}
          else {if(attempted)this.uncertainVariant=variantId;this.status(attempted?this.text.add_error:this.text.error,true);}
        } finally {
          if(this.isConnected){this.lock(false);this.ui.add.disabled=this.addedVariant===variantId||this.uncertainVariant===variantId||this.unavailable.has(variantId)||!this.ui.variant.options.length;if(this.addedVariant!==variantId)this.ui.add.textContent=this.text.add;}
        }
      }
      initCanvas() {
        this.ctx=this.ui.canvas.getContext('2d');
        if(!this.ctx){this.ui.canvas.hidden=true;this.querySelector('.ur-dice__fallback').style.display='block';return;}
        this.labels=new Map();
        for(let n=1;n<=20;n++){
          const texture=document.createElement('canvas');texture.width=256;texture.height=256;
          const ink=texture.getContext('2d');
          const gold=ink.createLinearGradient(0,72,0,190);gold.addColorStop(0,'#fff3c4');gold.addColorStop(.45,'#e8c774');gold.addColorStop(1,'#ae7732');
          ink.font='600 136px "Trebuchet MS", Arial, sans-serif';ink.textAlign='left';ink.textBaseline='alphabetic';
          const text=String(n),metrics=ink.measureText(text),marked=n===6||n===9;
          // Center the visible ink rather than the font's unequal side bearings.
          const left=metrics.actualBoundingBoxLeft||0,right=metrics.actualBoundingBoxRight||metrics.width;
          const ascent=metrics.actualBoundingBoxAscent||100,descent=metrics.actualBoundingBoxDescent||0;
          const x=128+(left-right)/2,y=128+(ascent-descent)/2-(marked?9:0);
          ink.lineWidth=2.5;ink.strokeStyle='#2b172d';ink.strokeText(text,x,y);
          ink.fillStyle=gold;ink.fillText(text,x,y);
          if(marked){ink.strokeStyle='#e8c774';ink.lineWidth=6;ink.lineCap='round';ink.beginPath();ink.moveTo(98,y+descent+14);ink.lineTo(158,y+descent+14);ink.stroke();}
          this.labels.set(n,texture);
        }
        this.rotation=D20.rest(D20.faces.findIndex(f=>f.number===20),.12);
        this.observer=new ResizeObserver(()=>this.draw(this.rotation,0));
        this.observer.observe(this.ui.canvas);
        this.draw(this.rotation,0);
      }
      draw(rotation,lift=0,slide=0) {
        if(!this.ctx)return;
        const c=this.ui.canvas,box=c.getBoundingClientRect(),dpr=Math.min(devicePixelRatio||1,2),w=box.width,h=box.height;
        if(!w||!h)return;
        if(c.width!==Math.round(w*dpr)||c.height!==Math.round(h*dpr)){c.width=Math.round(w*dpr);c.height=Math.round(h*dpr);}
        const ctx=this.ctx;ctx.setTransform(dpr,0,0,dpr,0,0);ctx.clearRect(0,0,w,h);
        const {add,sub,mul,dot,unit,rotate}=D20;
        const scale=Math.min(w*.29,h*.37),cx=w/2,cy=h*.46,elevation=.52,distance=5.8;
        const view=([x,y,z])=>[x,y*Math.cos(elevation)-z*Math.sin(elevation),y*Math.sin(elevation)+z*Math.cos(elevation)];
        const projection=([x,y,z])=>{const perspective=distance/(distance-z);return [cx+x*scale*perspective,cy-y*scale*perspective];};
        const lowest=Math.min(...D20.vertices.map(p=>rotate(p,rotation)[1]));
        const translation=[slide,-D20.inradius-lowest+lift,0];
        const transform=p=>view(add(rotate(p,rotation),translation));
        const ground=projection(view([slide,-D20.inradius,0]));
        const shadow=ctx.createRadialGradient(ground[0],ground[1],1,ground[0],ground[1],scale*1.2);
        shadow.addColorStop(0,`rgba(0,0,0,${.55/(1+lift*2)})`);shadow.addColorStop(1,'rgba(0,0,0,0)');
        ctx.save();ctx.translate(ground[0],ground[1]);ctx.scale(1,.32);ctx.translate(-ground[0],-ground[1]);ctx.fillStyle=shadow;ctx.fillRect(ground[0]-scale*1.3,ground[1]-scale*1.3,scale*2.6,scale*2.6);ctx.restore();
        const key=unit([-.6,.9,1.5]),fill=unit([.9,.1,.4]);
        const visible=D20.surfaces.map(s=>({...s,points:s.points.map(transform),center:transform(s.center),normal:view(rotate(s.normal,rotation))})).filter(s=>dot(s.normal,sub([0,0,distance],s.center))>0).sort((a,b)=>a.center[2]-b.center[2]);
        for(const s of visible){
          const p=s.points.map(projection),n=s.normal;
          const diffuse=Math.max(0,dot(n,key)),side=Math.max(0,dot(n,fill));
          const half=unit(add(key,unit(sub([0,0,distance],s.center))));
          const shine=Math.pow(Math.max(0,dot(n,half)),26),bevel=s.kind!=='face';
          const light=10+diffuse*17+side*4+shine*15+(bevel?5:0);
          const gradient=ctx.createLinearGradient(p[0][0],p[0][1],p[2][0],p[2][1]);
          gradient.addColorStop(0,`hsl(273 38% ${light+3}%)`);gradient.addColorStop(.55,`hsl(271 41% ${light}%)`);gradient.addColorStop(1,`hsl(270 42% ${Math.max(6,light-4)}%)`);
          ctx.beginPath();ctx.moveTo(...p[0]);for(const point of p.slice(1))ctx.lineTo(...point);ctx.closePath();
          ctx.fillStyle=gradient;ctx.fill();ctx.strokeStyle=`hsl(272 32% ${light}%)`;ctx.lineWidth=.65;ctx.stroke();
          if(s.kind==='face'){
            const f=D20.faces.find(face=>face.number===s.number),size=.33;
            const quad=[[-size,size],[size,size],[size,-size],[-size,-size]].map(([x,y])=>projection(transform(add(f.center,add(mul(f.right,x),mul(f.up,y))))));
            ctx.save();ctx.clip();this.paintLabel(this.labels.get(s.number),quad);ctx.restore();
          }
        }
      }
      paintLabel(texture,quad) {
        // Project the small label patch as two triangles in its face plane.
        // Hidden faces are already removed by the solid-surface renderer.
        const ctx=this.ctx,S=256;
        const drawTriangle=(src,dst)=>{
          const [a,b,c]=src,[p,q,r]=dst,den=a[0]*(b[1]-c[1])+b[0]*(c[1]-a[1])+c[0]*(a[1]-b[1]);
          const coeff=values=>[(values[0]*(b[1]-c[1])+values[1]*(c[1]-a[1])+values[2]*(a[1]-b[1]))/den,(values[0]*(c[0]-b[0])+values[1]*(a[0]-c[0])+values[2]*(b[0]-a[0]))/den,(values[0]*(b[0]*c[1]-c[0]*b[1])+values[1]*(c[0]*a[1]-a[0]*c[1])+values[2]*(a[0]*b[1]-b[0]*a[1]))/den];
          const x=coeff([p[0],q[0],r[0]]),y=coeff([p[1],q[1],r[1]]);
          ctx.save();ctx.beginPath();ctx.moveTo(...p);ctx.lineTo(...q);ctx.lineTo(...r);ctx.closePath();ctx.clip();ctx.transform(x[0],y[0],x[1],y[1],x[2],y[2]);ctx.drawImage(texture,0,0);ctx.restore();
        };
        drawTriangle([[0,0],[S,0],[S,S]],[quad[0],quad[1],quad[2]]);
        drawTriangle([[0,0],[S,S],[0,S]],[quad[0],quad[2],quad[3]]);
      }
      animate() {
        const face=randomIndex(20),target=D20.rest(face,Math.random()*Math.PI*2);
        this.lastRoll=D20.faces[face].number;
        if(this.ui.motion.checked||this.motion.matches||!this.ctx){this.rotation=target;this.draw(this.rotation,0);return Promise.resolve();}
        this.ui.skip.hidden=false;
        return new Promise(resolve=>{
          const start=performance.now(),from=[...this.rotation];
          let done=false;
          const finish=()=>{if(done)return;done=true;cancelAnimationFrame(this.frame);this.rotation=target;this.draw(this.rotation,0);this.ui.skip.hidden=true;this.finishAnimation=null;resolve();};
          this.finishAnimation=finish;
          const step=now=>{
            if(done)return;
            const t=Math.min(1,(now-start)/2100),ease=1-Math.pow(1-t,3);
            const tumble=D20.product(D20.axis([1,.28,.3],Math.PI*4*ease),D20.axis([.2,1,.4],Math.PI*2*ease));
            let r=D20.product(tumble,D20.slerp(from,target,ease));
            if(t>.78){const settle=(t-.78)/.22;r=D20.product(D20.axis([0,0,1],Math.sin(settle*Math.PI*3)*.075*(1-settle)),r);}
            const lift=Math.abs(Math.sin(t*Math.PI*3))*.55*Math.pow(1-t,1.4),slide=Math.sin(t*Math.PI*2)*.28*(1-t);
            this.draw(r,lift,slide);if(t>=1)finish();else this.frame=requestAnimationFrame(step);
          };
          this.frame=requestAnimationFrame(step);
        });
      }
    }
    customElements.define('ur-dice-discovery',DiceDiscovery);
  })();

  } catch(e) { console.error(e); }
})();
})();
